<template>
  <div class="bx--navigation-section">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'WaSideMenuSection'
}
</script>